import { useMutation } from '@tanstack/react-query';
import {
  submitFeedback,
  type SubmitFeedbackPayload,
} from '@/lib/api/common/feedback.api';

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: (input: SubmitFeedbackPayload) => submitFeedback(input),
  });
}
